import { SvgProps } from "components/icons/types";

export const AngleDown = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 -2.964 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M11.29 0L6.3505 4.9395C6.25543 5.03074 6.12877 5.0817 5.997 5.0817C5.86523 5.0817 5.73857 5.03074 5.6435 4.9395L0.707 0.00250006L0 0.7095L4.9365 5.6465C5.22243 5.91901 5.60226 6.07103 5.99725 6.07103C6.39224 6.07103 6.77207 5.91901 7.058 5.6465L11.997 0.707L11.29 0Z"
      fill="currentColor"
    />
  </svg>
);
